export default {
	END_OF_MONTH_CONFIG: 'companies/:company_id/end-of-month/config',
	END_OF_MONTH_PROPERTY_HISTORY: 'companies/:company_id/properties',
	END_OF_MONTH_COMPANY_HISTORY: 'companies/:company_id/end-of-month/history',
	END_OF_MONTH_REPORTS: 'companies/:company_id/end-of-month/reports',
}
